import { useState, useEffect } from "react";
import axios from "axios";
import PermissionGate from "../layout/PermissionGate";

const Integration = () => {
  const [data, setData] = useState({});
  const [_, setIsLoading] = useState(false);
  const token = localStorage.getItem("token");

  const fetchIntegraion = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT}ordable/integration/get`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (res.data.code === 1) {
        setData(res?.data?.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchIntegraion();
  }, []);

  return (
    <div className="row g-5 g-lg-10 mb-5">
      {/*begin::Card*/}
      <PermissionGate required={`view_ordable_integration`}>
        <div className="card">
          {/*begin::Card header*/}
          <div className="card-header">
            {/*begin::Card title*/}
            <div className="card-title">Integration</div>
            {/*begin::Card title*/}
          </div>
          {/*end::Card header*/}
          {/*begin::Card body*/}
          <div className="card-body py-4">
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>URL</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{data?.data?.name}</td>
                    <td>{data?.data?.url}</td>
                    <td>{data?.data?.status}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          {/*end::Card body*/}
        </div>
      </PermissionGate>
      {/*end::Card*/}
    </div>
  );
};

export default Integration;
